import React, { FC, memo, useMemo, useState } from 'react'
import { FeatureGroup } from 'react-leaflet'
import { LatLngExpression, LeafletEventHandlerFnMap, LeafletMouseEvent, PathOptions } from 'leaflet'
import { MapCadastralPlotFragment } from '@foros-fe/graphql'
import { LayerGeoJSON } from './LayerGeoJSON'
import { GeoJSONData } from '../../../utils/cartography'
import { AuctionPopup } from '../Popups/AuctionPopup'
import { AuctionProperties } from './DeflateLayer'

type AuctionGroupCadastralPlotProps = MapCadastralPlotFragment & {
  auction: AuctionProperties
  geoJSON: GeoJSONData
  pathOptions: PathOptions
  eventHandlers: LeafletEventHandlerFnMap
}

export const CadastralPlotsGroup: FC<AuctionGroupCadastralPlotProps> = memo(
  ({ geoJSON: [_, geoJSON], eventHandlers, pathOptions, auction, id }) => {
    const [popupPosition, setPopupPosition] = useState<LatLngExpression | null>(null)
    const featureGroupEventHandlers = useMemo(
      () => ({
        ...eventHandlers,
        click: ({ latlng }: LeafletMouseEvent) => setPopupPosition([latlng.lat, latlng.lng]),
      }),
      [eventHandlers]
    )
    const geoJSONFeatures = useMemo(
      () =>
        geoJSON.map((geometry) => ({
          geometry,
          properties: auction,
          type: 'Feature',
        })),
      [auction, geoJSON]
    )

    return geoJSONFeatures.length ? (
      <>
        <FeatureGroup eventHandlers={featureGroupEventHandlers} pathOptions={pathOptions}>
          {geoJSONFeatures.map((data, index) => (
            <LayerGeoJSON key={index} color='secondary' data={data} />
          ))}
        </FeatureGroup>
        {popupPosition ? (
          <AuctionPopup position={popupPosition} cadastralPlotId={id} auctionId={auction.id} />
        ) : null}
      </>
    ) : null
  }
)
